import { useMutation, useQueryClient } from '@tanstack/react-query';

import { putAccountingIntegrationData } from '@krea/common/store/field-requests/api';
import {
  DELEGATED_FIELD_REQUESTS_STORE_KEY,
  ONE_FIELD_REQUEST_STORE_KEY,
} from '@krea/common/store/queryClient';

export const usePutAccountingIntegrationData = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ accountingDataId, organisationNumber, serviceType }) => {
      putAccountingIntegrationData(
        accountingDataId,
        serviceType,
        organisationNumber,
      );
    },
    onSuccess: async (_, { fieldRequestID, isDelegated }) => {
      await queryClient.invalidateQueries({
        queryKey: [ONE_FIELD_REQUEST_STORE_KEY, fieldRequestID],
      });

      if (isDelegated) {
        await queryClient.invalidateQueries({
          queryKey: [DELEGATED_FIELD_REQUESTS_STORE_KEY],
        });
      }
    },
    onError: (err) => {
      console.error('Error PUTing accounting integration data', err);
    },
  });
};
